import { Fade } from '@mui/material';
import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiTooltipStyles = (variables: Variables) => ({
    defaultProps: {
        TransitionComponent: Fade,
    },
    styleOverrides: {
        tooltip: {
            background: 'white',
            color: variables.colors.palette.text.primary,
            boxShadow: variables.boxShadows.tooltipShadow,
        },
    },
});

export default createMuiTooltipStyles;
